export default {
    "common.Accept": "受け入れる",
    "common.Add": "追加する",
    "common.Cancel": "キャンセル",
    "common.Close": "閉じる",
    "common.Delete": "削除する",
    "common.Save": "保存",

    "common.accept": "受け入れる",
    "common.add": "追加する",
    "common.cancel": "キャンセル",
    "common.close": "閉じる",
    "common.delete": "削除",
    "common.save": "保存"
}